import(/* webpackMode: "eager" */ "/home/academyr/crm.24agency.ro/src/app/(admin)/layout.jsx");
